import AuthQuote from "@/components/auth/auth.quote";
import AuthLogo from "@/components/auth/auth.logo";
import AuthTitle from "@/components/auth/auth.title";
import SignupForm from "./signup.form";
import { Link } from "react-router-dom";
import { PATH_HOME, PATH_LOGIN, PATH_ONBOARDING } from "@/routes/paths";
import { useAppDispatch, useAppSelector } from "@/hooks/redux-hooks";
import { Navigate } from "react-router-dom";
import { useEffect } from "react";
import { initializeApp } from "@/store/reducers/auth.reducer";
import Loader from "@/components/Loader";

const SignupContainer = () => {
  const dispatch = useAppDispatch();
  const { initialized, isLoggedIn, user } = useAppSelector((s) => s.auth);

  useEffect(() => {
    dispatch(initializeApp());
  }, [dispatch]);

  if (!initialized) return <Loader />;
  if (initialized && isLoggedIn && user?.onboarding) return <Navigate to={PATH_ONBOARDING} />;
  if (initialized && isLoggedIn) return <Navigate to={PATH_HOME} />;
  return (
    <div className="grid lg:grid-cols-2 min-h-screen">
      <div className="w-full h-full bg-gray-200 p-6 lg:p-20">
        <div className="mx-auto max-w-sm">
          <AuthLogo />
          <AuthTitle />
          <SignupForm />
          <p className="text-sm text-gray-800 text-center mt-8">
            Already registered Let's{" "}
            <Link to={PATH_LOGIN} className="font-bold hover:underline text-black">
              Login
            </Link>
          </p>
        </div>
      </div>

      <AuthQuote />
    </div>
  );
};

export default SignupContainer;
